/**
 * A vertical divider you can drag. Always drawn as a line, with a wider
 * invisible grip, so people can see where to grab; the 4px-wide invisible
 * handles before this were not found.
 */
export function ResizeHandle({ onResize, onDoubleClick, label, title }: { onResize: (clientX: number) => void; onDoubleClick?: () => void; label: string; title?: string }) {
  const start = (e: React.PointerEvent) => {
    e.preventDefault()
    // Iframes and terminals swallow pointer events mid-drag; cover them.
    const shield = document.createElement('div')
    shield.style.cssText = 'position:fixed;inset:0;z-index:9999;cursor:col-resize'
    document.body.appendChild(shield)
    const move = (m: PointerEvent) => onResize(m.clientX)
    const up = () => { window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', up); shield.remove() }
    window.addEventListener('pointermove', move)
    window.addEventListener('pointerup', up)
  }
  return (
    // shadcn's resizable look: a 1px line that only brightens on hover, and a
    // small grip in the middle; the wide tinted band and tooltip were loud.
    <div role="separator" aria-orientation="vertical" aria-label={title ? `${label}. ${title}` : label}
      onPointerDown={start} onDoubleClick={onDoubleClick}
      className="group relative z-10 w-px shrink-0 cursor-col-resize bg-border transition-colors delay-75 hover:bg-border-strong active:bg-ring/60">
      <div className="absolute inset-y-0 -left-1.5 w-3" />
      <div className="absolute top-1/2 left-1/2 h-6 w-1 -translate-x-1/2 -translate-y-1/2 rounded-full bg-border-strong opacity-0 transition-opacity delay-75 group-hover:opacity-100" />
    </div>
  )
}
